export const EXCLUDED_FUNCTIONS = ['processTicksAndRejections', 'runMicrotasks', 'runNextTicks'];
